import React from "react";
import { TactiqLogo } from "../brand/TactiqAssets";
import { Instagram, Linkedin, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--tq-navy)] text-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-white/15">
          <div className="md:col-span-5">
            <TactiqLogo dark withTag />
            <p className="mt-6 text-white/70 max-w-sm">
              A Toronto-based marketing company turning custom-label water bottles
              into the most-shared brand touchpoint in your campaign.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="mailto:hello@tactiq.ca"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center"
                aria-label="Email"
                data-testid="footer-email"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4" style={{ color: "#93C5FD" }}>
              Explore
            </div>
            <ul className="space-y-3">
              <li><a href="#use-cases" className="hover:text-white/100 text-white/70">Use Cases</a></li>
              <li><a href="#analytics" className="hover:text-white/100 text-white/70">QR Analytics</a></li>
              <li><a href="#process" className="hover:text-white/100 text-white/70">Process</a></li>
              <li><a href="#contact" className="hover:text-white/100 text-white/70">Contact</a></li>
              <li><a href="/admin" className="hover:text-white/100 text-white/70">Admin</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4" style={{ color: "#93C5FD" }}>
              Studio
            </div>
            <div className="text-white/85 space-y-2">
              <div className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 flex-shrink-0" />
                <span>2795 Slough St, Mississauga,<br />ON L4T 1G2, Canada</span>
              </div>
              <div>Ash Tandon · <a href="tel:+16472001753" className="underline">647-200-1753</a></div>
              <div>Aaishwari Chouhan · <a href="tel:+14168562809" className="underline">416-856-2809</a></div>
              <div><a href="mailto:hello@tactiq.ca" className="underline">hello@tactiq.ca</a></div>
            </div>
          </div>
        </div>

        {/* Mega wordmark */}
        <div className="py-12">
          <div className="tq-mega text-[clamp(4.5rem,16vw,16rem)] text-white/95 select-none">
            TACTIQ<span style={{ color: "#60A5FA" }}>®</span>
          </div>
        </div>

        <div className="pt-8 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/60 font-mono uppercase tracking-widest">
          <div>© {new Date().getFullYear()} Tactiq Experience · Toronto</div>
          <div>Your Brand. Every Sip.</div>
        </div>
      </div>
    </footer>
  );
};
